import { CacheKeys } from 'cache-keys-enum';
import { ApiRoute } from 'enums';
import { useQuery } from 'react-query';
import { EadNode } from 'types';
import fetch from 'utils/fetch';

export const useEadDetail = (id?: string) =>
  useQuery(
    [CacheKeys.EAD, id],
    () =>
      fetch(`/api/${ApiRoute.ARCHIVAL_AID}/ead/${id}`).then(
        async (r) => (await r.json()) as EadNode
      ),
    {
      enabled: !!id,
    }
  );
